export default "__VITE_ASSET__BG37Do2S__"